import request from '@/utils/request'
import { AxiosResult, AxiosPagination } from '@/typings/common'

//  获取列表数据
export function customerLabelList(data:any) {
  return request.post<AxiosPagination<any>>('/lbu/api/clueCustomer/label/findByPage', data)
}

export function batchSaveCustomerLabel(data:any) {
  return request.post<AxiosResult>('/lbu/api/clueCustomer/label/batchSave', data)
}
export function importCustomerLabel(data:any) {
  return request.post<AxiosResult>('/lbu/api/clueCustomer/label/import', data)
}
export function downloadCustomerLabelTemplate() {
  return request.post<AxiosResult>('/lbu/api/clueCustomer/label/template/download')
}
